import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: 0.05rem;
  display: flow-root;
  width: 100%;
`

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: auto;
  margin-bottom: auto;
  min-width: 100%;
  width: 100%;
`

export const Header = styled.th`
  border: 1px solid #ddd;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1.4rem;
  font-weight: 600;
  padding: 1.1rem 1.6rem;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  line-height: 1.6rem;
  font-family: ${({ theme }) =>
    theme.form?.table?.header?.fontFamily || 'inherit'};
  font-size: ${({ theme }) => theme.form?.table?.header?.fontSize || '1.4rem'};
  padding: ${({ theme }) =>
    theme.form?.table?.header?.padding || '1.1rem 1.6rem'};
  text-align: left;
  text-transform: uppercase;

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
`

export const Line = styled.tr`
  height: 4rem;
  :nth-child(even) {
    background-color: ${({ theme }) => theme.colors.rowTable};
  }
`

export const Column = styled.td`
  border: 1px solid #ddd;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1.4rem;
  padding: 1.1rem 1.6rem;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  line-height: 1.6rem;
  padding: ${({ theme }) =>
    theme.form?.table?.column?.padding || '1.1rem 1.6rem'};

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  &#actions-column {
    padding: 0.6rem 0 0.6rem 0;
    width: 4.8rem;
    div {
      margin: auto;
    }
    button {
      display: block;
      margin: auto;
    }
  }

  button {
    width: 3.2rem;
  }
`

export const StatusBadge = styled.span<{ status: string; clickable?: boolean }>`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  min-width: 80px;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    ${({ clickable }) =>
      clickable &&
      css`
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      `}
  }

  ${({ status, theme }) =>
    status === 'success'
      ? css`
          background-color: ${theme.colors?.success || '#4caf50'}1a;
          color: ${theme.colors?.success || '#4caf50'};
          border: 1px solid ${theme.colors?.success || '#4caf50'};
        `
      : css`
          background-color: ${theme.colors?.error || '#f44336'}1a;
          color: ${theme.colors?.error || '#f44336'};
          border: 1px solid ${theme.colors?.error || '#f44336'};
        `}
`
